import type { ProDriverListSearchParams } from "@/app/ProDrivers/Common/Routes/proDriverRoutes";
import {
  PaidDriverListQueryVariables,
  QueryProDriversOrderByColumn,
  SortOrder,
} from "@/gql/graphql";

export function getProDriverQueryVariables(
  searchParams: ProDriverListSearchParams,
): PaidDriverListQueryVariables {
  const baseVariables: PaidDriverListQueryVariables = {
    first: 20,
    search: searchParams.proDriverSearch || undefined,
    page: 1,
    archived: false,
  };

  if (searchParams.proDriverSearch) {
    return baseVariables;
  }

  return {
    ...baseVariables,
    orderBy: [
      {
        order: SortOrder.Desc,
        column: QueryProDriversOrderByColumn.CreatedAt,
      },
    ],
  };
}
